<template>
    <v-container class="grey-lighten-3 full-height">
        <v-row justify="center">
            <v-col cols="12" xl="10" lg="11" md="12">
                <div style="background-color: white; color: black; font-family: 'Times New Roman', serif; max-width: 280mm; width: 100%; min-height: 297mm; padding: 20px; margin: 0 auto;" id="printable-area">

                <div style="display: flex; justify-content: space-between; margin-bottom: 24px; border-bottom: 1px solid #ccc; padding-bottom: 5px;">
                    <div style="display: flex; align-items: center;">
                        <div style="margin-right: 16px;"></div>
                        <div>
                            <img :src="`${getFileServerUrl.replace(/\/$/, '')}/${getPassData?.branch?.company?.logo || 'uploads/demo_images/user.png'}`" style="width: 200px; height: 100px; border-radius: 4px;" />
                        </div>
                    </div>

                    <div style="text-align: right;">
                        <p style="color: #444; letter-spacing: 1px; font-size: 20px; text-transform: uppercase; margin: 0;">
                            {{ getPassData?.branch?.company?.name }}
                        </p>
                        <p style="font-size: 14px; text-align: right; margin: 5px 0 0 0;">
                            {{ getPassData?.branch?.company?.address }}
                        </p>
                    </div>
                </div>

                <div style="text-align: center; margin-bottom: 24px;">
                    <h2 style="font-weight: bold; text-decoration: underline; margin: 0;">
                        TRUCK CHALLAN
                    </h2>
                </div>
                <!-- Main Content -->
                <div>
                    <p style="font-weight: bold; text-decoration: underline; margin-bottom: 10px;">Address: </p>
                    <div v-html="getPassData?.address"></div>

                    <p style="font-weight: bold; margin: 20px 10px 0px 0;"><span style="text-decoration: underline;">Readymade Garments: </span></p>
                </div>

                <div style="display: flex; margin-top: 20px;">
                    <div style="display: flex; gap: 10px;">
                        <p style="font-weight: bold;">Total: </p>
                        <p style="font-weight: bold;"> {{ getPassData?.total_bag }} Carton/Bag </p>
                    </div>
                </div>

                <!-- Depreciation Details Table -->
                <div style="margin-top: 20px;" >
                    <p><b>Transporter Name:</b> {{ getPassData?.transporter_name }}</p>
                    <p><b>Driver Name:</b> {{ getPassData?.driver_name }}</p>
                    <p><b>Vehicle No:</b> {{ getPassData?.vehicle_no }}</p>
                    <p><b>Mobile No:</b> {{ getPassData?.mobile_no }}</p>
                    <p><b>Lock No:</b> {{ getPassData?.lock_no }}</p>
                    <p><b>Container No:</b> {{ getPassData?.container_no }}</p>
                </div>

                <div style="display: flex; margin-top: 64px;">
                    <div style="flex: 1; padding: 16px;">
                        <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align: center; padding-top: 6px;">
                            <span>Received By</span>
                        </p>
                    </div>
                    <div style="flex: 1; padding: 16px;"></div>
                    <div style="flex: 1; padding: 16px;">
                        <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align: center; padding-top: 6px;">
                            <span>Send By</span>
                        </p>
                    </div>
                </div>

                <div style="text-align: center; margin-top: 16px;">
                    <span style="font-size: 12px;">
                        <hr>
                        UAE Address: Dnata Building Freight Gate 5 Building, Office no 210, 2nd Floor, Block E, Dubai Airport Free Zone Authorities Premises, DAFZA, Dubai. 
                        <br>
                        Cell: +971 507155639& +971 566491905
                        <br>
                        Dhaka Office: House Name: Sahnaz Sultana house no: 14 Road no: 32 Lift: 6-a Gulshan-1, Dhaka-1212 , Bnagladesh. 
                        <br> Cell: +88 01898461015& +88 01330456380
                    </span>
                </div>
                </div>
            </v-col>
        </v-row>

        <v-row class="d-print-none mb-4" justify="center">
            <v-col cols="12" md="8" lg="9" class="d-flex justify-center gap-2">
                <!-- <v-btn color="success" prepend-icon="mdi-download" @click="downloadPDF">
                    Print PDF
                </v-btn> -->
                <v-btn color="success" prepend-icon="mdi-download" @click="printInvoice">
                  Print PDF
              </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import html2pdf from "html2pdf.js";
import { categoryLabel, calTypeLabel } from "@/plugins/helpers.js";

export default {
    name: "GatePassInvoice",
    data: () => ({
        mainId: null,
        getPassData: null,
    }),
    
    watch: {},

    created() {
        const id = this.$route.query.id;
        this.mainId = id;
        this.$store.dispatch("getInvGatePassById", id).then((response) => {
            this.getPassData = response;
        });
    },
    computed: {
        getCurrentCompany() {
            this.companyInfo = this.$store.getters.getCurrentCompany;
            return this.$store.getters.getCurrentCompany;
        },
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl;
        },
    },  

    methods: {
        categoryLabel,
        calTypeLabel,
        formatDate(date) {
            if (!date) return "-";
            const d = new Date(date);
            return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
                .toString()
                .padStart(2, "0")}/${d.getFullYear()}`;
        },
        formatDateTime(dateTime) {
            if (!dateTime) return "-";
            const d = new Date(dateTime);
            return `${this.formatDate(dateTime)} ${d.toLocaleTimeString()}`;
        },
        formatNumber(num) {
            return num ? Number(num).toFixed(2) : "0.00";
        },
        async downloadPDF() {
            const element = document.getElementById("printable-area");
            const opt = {
                margin: [0.5, 0.5],
                filename: `gate-pass-invoice-${this.getPassData?.code}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
            };
            await html2pdf().set(opt).from(element).save();
        },
        async printInvoice() {
            const printContent = document.getElementById("printable-area").innerHTML;
            
            const html = `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Gate Pass Invoice</title>
                    <style>
                        * { margin: 0; padding: 0; box-sizing: border-box; }
                        body { font-family: 'Times New Roman', serif; color: #000; line-height: 1.4; }
                        #printable-area { max-width: 280mm; margin: 0 auto; background: white; padding: 20px; }
                        img { max-width: 100%; height: auto; display: block; }
                        @media print {
                            body { margin: 0; padding: 0; }
                            #printable-area { margin: 0; box-shadow: none; max-width: 100%; }
                        }
                    </style>
                </head>
                <body>
                    <div id="printable-area">${printContent}</div>
                </body>
                </html>
            `;

            const w = window.open("", "PRINT", `width=${screen.width},height=${screen.height}`);
            w.document.open();
            w.document.write(html);
            w.document.close();

            await new Promise((res) => setTimeout(res, 500));
            w.focus();
            w.print();
            w.close();
        }

    },
};
</script>

<style scoped>
.grey-lighten-3 {
    background-color: #eeeeee !important;
}
.full-height {
    min-height: 100vh;
}
.gap-2 {
    gap: 8px;
}
</style>
